import { Button } from '@/components/ui/button';

interface ModalFooterProps {
  primaryLabel: string;
  onPrimary: () => void;
  onCancel?: () => void;
  showCancel?: boolean;
  secondaryLabel?: string;
  variant?: string;
  loading?: boolean;
  disabled?: boolean;
  primaryClassName?: string;
}

export function ModalFooter({
  primaryLabel,
  onPrimary,
  onCancel,
  showCancel = true,
  secondaryLabel,
  variant = "default",
  loading = false,
  disabled = false,
  primaryClassName
}: ModalFooterProps) {
  return (
    <div className="sticky bottom-0 left-0 right-0 p-6 pb-[calc(1.5rem+env(safe-area-inset-bottom))] border-t bg-background/95 backdrop-blur-sm space-y-2 z-10">
      <Button 
        onClick={onPrimary}
        disabled={loading || disabled}
        className={`w-full ${variant === 'calendar' ? 'bg-calendar text-calendar-foreground hover:bg-calendar/90' : primaryClassName || ''}`}
        variant={variant === 'calendar' ? 'default' as any : variant as any}
      >
        {loading ? 'Enregistrement...' : primaryLabel}
      </Button>
      {showCancel && onCancel && (
        <Button 
          variant="outline" 
          onClick={onCancel}
          className="w-full hover:bg-muted hover:text-muted-foreground"
        >
          {secondaryLabel || 'Annuler'}
        </Button>
      )}
    </div>
  );
}